import { PRODUCTION_URLS } from '../config/envs.esm.js';
import { Env } from './infra.esm.js';

var getRegionalDomain = function(env) {
    switch(env){
        case Env.Development:
            return "lmnddev.com";
        case Env.Sandbox:
            return "lmndsandbox.com";
        case Env.Staging:
            return "lmndstaging.com";
        case Env.Test:
            return "lmndtest.com";
        default:
            throw new Error("Invalid Env");
    }
};
function getServicesUrl(env, envId, edgeService) {
    switch(env){
        case Env.Test:
        case Env.Development:
        case Env.Sandbox:
        case Env.Staging:
            {
                var regionalDomain = getRegionalDomain(env);
                return "https://".concat(edgeService, "-").concat(envId, ".").concat(regionalDomain);
            }
        case Env.Production:
            {
                return PRODUCTION_URLS[edgeService];
            }
        default:
            throw new Error("Invalid Env");
    }
}
function buildServiceUrl(env, envId, edgeService, path) {
    return getServicesUrl(env, envId, edgeService) + (path !== null && path !== void 0 ? path : "");
}

export { buildServiceUrl, getRegionalDomain, getServicesUrl };
